import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BehaviourService {
  private messageSource: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private arraySource = new BehaviorSubject<[Array<any>, string]>([[], '']);
  currentMessage: Observable<string> = this.messageSource.asObservable();
  currentArray = this.arraySource.asObservable();

  sendEvent(data) {
    this.messageSource.next(data);
  }

  sendArrayEvent(array, string) {
    this.arraySource.next([array, string]);
  }
}
